/**
 * highlight.js のラッパ（言語登録を集約。08_directive-syntax.md §6.9）。
 *
 * 必要な言語のみを個別 import し、CDN は使わない（design.md D3「ビルド同梱（自己ホスト）」）。
 */
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import css from "highlight.js/lib/languages/css";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import kotlin from "highlight.js/lib/languages/kotlin";
import markdown from "highlight.js/lib/languages/markdown";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import scss from "highlight.js/lib/languages/scss";
import sql from "highlight.js/lib/languages/sql";
import typescript from "highlight.js/lib/languages/typescript";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";

hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("java", java);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("css", css);
hljs.registerLanguage("scss", scss);
hljs.registerLanguage("json", json);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("python", python);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("kotlin", kotlin);
hljs.registerLanguage("plaintext", plaintext);

const ALIASES: Readonly<Record<string, string>> = {
  ts: "typescript",
  js: "javascript",
  html: "xml",
  yml: "yaml",
  sh: "bash",
  shell: "bash",
  md: "markdown",
  text: "plaintext",
};

function resolveLanguage(lang: string): string {
  return ALIASES[lang] ?? lang;
}

/**
 * 未登録の言語 / 言語指定なしならハイライトを適用しない（自動判定 highlightAuto は使わない）。
 */
export function highlightElement(el: HTMLElement, lang: string | null): void {
  if (!lang) return;
  const resolved = resolveLanguage(lang);
  if (!hljs.getLanguage(resolved)) return;

  const source = el.textContent ?? "";
  const result = hljs.highlight(source, { language: resolved });
  el.innerHTML = result.value;
  el.classList.add("hljs");
}
